import type { HistoricoSimulacaoDialogProps } from "./types-historico-simulacao-dialog";
import { useHistoricoSimulacaoDialog } from "./use-historico-simulacao-dialog";
import { HistoricoSimulacaoDialogView } from "./view-historico-simulacao-dialog";

/** Histórico de simulações (HU 2221): listagem paginada no servidor; a linha abre o detalhe. */
export function HistoricoSimulacaoDialog(props: HistoricoSimulacaoDialogProps) {
  const vm = useHistoricoSimulacaoDialog(props);

  return <HistoricoSimulacaoDialogView {...vm} />;
}

export type * from "./types-historico-simulacao-dialog";
